import horseTracker from './HorseTracker';

export default horseTracker;



// WEBPACK FOOTER //
// ./src/js/shared/horseTracker/index.js